
//
// Asynchronous Campaign Stats
//
// Get stats per-recipient in mailchimp campaigns after page load in case the campaign is very
// large.
//

module.exports = function AsyncCampaignStats ($host, config) {

  // Config

  var requestUrl = config.requestUrl;


  // Dom

  var $generateForm   = $('[data-generate-form]',     $host);
  var $pendingNotice  = $('[data-pending-notice]',    $host);
  var $upToDateNotice = $('[data-up-to-date-notice]', $host);
  var $missingNotice  = $('[data-missing-notice]',    $host);


  // Functions



  // Listeners

  function onJsonStatsAvailable (stats) {

    $pendingNotice.hide();

    if (stats.num_missing_vouchers > 0) {
      $missingNotice.show();
      $generateForm.show();

      var $noticeBody = $missingNotice.find('.notice-body');
      $noticeBody.text( pluraliseBody($noticeBody.text().trim(), stats.num_missing_vouchers) );

      var $buttonBody = $generateForm.find('.button');
      $buttonBody.text( pluraliseBody($buttonBody.text().trim(), stats.num_missing_vouchers) );

    } else {
      log(' show uptodate', $upToDateNotice.length);
      $upToDateNotice.show();
    }
  }


  // Init

  log('AsyncCampaignStats - fetching ajax stats for campaign');
  fetchJson(requestUrl, onJsonStatsAvailable, log);

};


